import UtilsArray from './utils.array';
import UtilsDate from './utils.date';
import UtilsString from './utils.string';
import UtilsBoolean from './utils.boolean';
import UtilsScroll from './utils.scroll';

export default {
  array: UtilsArray,
  date: UtilsDate,
  string: UtilsString,
  boolean: UtilsBoolean,
  scroll: UtilsScroll,
};
